import { useState } from 'react';
import { SystemIcon } from '@monorepo/nova-icons';
import {
  Box,
  Drawer,
  IconButton,
  Stack,
  useBreakpoints,
  useTheme,
} from '@monorepo/nova-ui';
import { useLocalStorage } from '@monorepo/react-hooks';
import { IsLoggedInKey } from '@monorepo/types';
import { LanguageDropdown } from '../../language-dropdown';
import { BalanceButton } from './balance-button';
import { Logo } from './logo';
import { SubMenuMobile } from './submenu-mobile';

export const MenuMobile = ({ userId }: { userId?: string } = {}) => {
  const theme = useTheme();
  const { isMobile } = useBreakpoints();
  const { storedValue: isUserLoggedIn } = useLocalStorage(IsLoggedInKey, false);
  const [openMenu, setOpenMenu] = useState(false);

  const toggleDrawer = (newOpen: boolean) => () => {
    setOpenMenu(newOpen);
  };

  const handleCloseSubMenu = () => {
    setOpenMenu(false);
  };

  return (
    <div className="menu-mobile">
      <IconButton
        className="menu-mobile__trigger"
        aria-label="Menu"
        onClick={toggleDrawer(true)}
        sx={{
          width: 24,
          height: 24,
          p: 0,
        }}
      >
        <SystemIcon
          className="menu-mobile__trigger-icon"
          iconName="Menu"
          viewBox="0 0 24 25"
          sx={{ fontSize: 24 }}
        />
      </IconButton>
      <Drawer
        className="menu-mobile__drawer"
        open={openMenu}
        onClose={toggleDrawer(false)}
        sx={{
          '& .MuiDrawer-paper': {
            width: '296px',
          },
        }}
      >
        <header
          className="menu-mobile__header"
          style={{
            borderBottom: `4px solid ${theme.palette.background.contrast}`,
            backgroundColor: theme.palette.background.default,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '16px 24px',
          }}
        >
          <Logo />
          <IconButton
            className="menu-mobile__close-button"
            onClick={toggleDrawer(false)}
            sx={{
              width: 16,
              height: 16,
              p: 0,
            }}
          >
            <SystemIcon
              iconName="X"
              color={theme.palette.text.main}
              sx={{ width: 16, height: 16 }}
            />
          </IconButton>
        </header>
        <Stack
          justifyContent="space-between"
          flex={1}
          gap={2}
          sx={{
            background: theme.palette.background.default,
          }}
        >
          <SubMenuMobile handleCloseSubMenu={handleCloseSubMenu} />
          {isMobile && (
            <Box alignSelf="flex-start" paddingLeft={4}>
              <LanguageDropdown />
            </Box>
          )}
        </Stack>
        <footer
          className="menu-mobile__footer"
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: isUserLoggedIn ? 'space-between' : 'flex-end',
            gap: 2,
            padding: '16px 24px',
            borderTop: `4px solid ${theme.palette.background.contrast}`,
            background: theme.palette.background.default,
          }}
        >
          {isUserLoggedIn && <BalanceButton userId={userId} />}
        </footer>
      </Drawer>
    </div>
  );
};
